import { IDateUtils } from "common.ui/CustomForms/Utils/types";
import moment from "moment/moment";
import { formatDateTime } from "common.ui/Helpers/dateExtensions";

export class DateUtils implements IDateUtils {
    private readonly _cultureDateFormat: string;
    private readonly _cultureDateTimeFormatJS: string;

    constructor(cultureDateFormat: string, cultureDateTimeFormatJS: string) {
        this._cultureDateFormat = cultureDateFormat;
        this._cultureDateTimeFormatJS = cultureDateTimeFormatJS;
    }

    getFormattedDate = (date: moment.Moment) => {
        return DateUtils.formatDate(date, this._cultureDateFormat);
    };

    getFormattedDateTime = (date: moment.Moment) => {
        return DateUtils.formatDate(date, this._cultureDateTimeFormatJS);
    };

    static formatDate(date: moment.Moment, format: string): string {
        if (!date) return "";

        // date.isValid to check if this is a moment object or not;
        if (!date.isValid) {
            date = moment(date);

            if (!date.isValid()) return date.toString();
        }

        const actDateFormatted = date.format().slice(0, -6);

        return formatDateTime(actDateFormatted, format);
    }
}
